import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
}));
